import { getServerSideTranslationProps } from "@/utils/translation";
import Layout from "@/components/Layout/Layout";
import SEO from '@/components/Layout/MetadataManager'
import TermsAndConditions from "@/features/LegalPages/TermsAndConditions/TermsAndConditions";

const i18nNamespaces = ['termsAndConditions', 'termsAndConditions-ios']

export const getStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await getServerSideTranslationProps({ locale: 'en', i18nNamespaces })),
        },
    }
}

const TermsPage = () => {
    return (
        <Layout>
            <SEO title="Terms and Conditions" description="Terms and Conditions page" fullTitle />
            <TermsAndConditions isIOS={true} />
        </Layout>
    )
}

export default TermsPage